<template>
  <Modal
    :title="computedTitle"
    :modal="modalTag"
    cardTextClass="pa-0"
    @close="$emit('close')"
    @save="save"
  >
    <div slot="header-right">
      <v-btn fab small text @click="$emit('close')" class="mr-3">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-btn fab small color="primary" @click="save" :loading="loading">
        <v-icon>mdi-check</v-icon>
      </v-btn>
    </div>
    <v-row slot="inner-body" no-gutters>
      <v-col cols="12" class="pa-0">
        <v-form
          @submit.prevent="save"
          v-model="valid"
          ref="tagForm"
          lazy-validation
        >
          <v-col cols="12" class="px-4">
            <Input
              label="Descrição"
              filled  
              @input="tag.descricao = $event"
              :value="tag.descricao"
              :rules="[rules.required]"
              :autofocus="modalTag"
            />
            <Select
              @change="tag.cor = $event"
              :value="tag.cor"
              :items="colorsPicker"
              label="Cor"
              name="cor"
              filled
            >
              <template v-slot:selection="{ item }">
                <div class="d-flex align-center">
                  <v-list-item class="pl-0">
                    <v-chip small :color="item.value"></v-chip>
                    <span class="pl-3">{{ item.text }}</span>
                  </v-list-item>
                </div>
              </template>
              <template v-slot:item="{ item }">
                <div class="d-flex align-center">
                  <v-list-item class="pl-0">
                    <v-chip small :color="item.value"></v-chip>
                    <v-list-item>{{ item.text }}</v-list-item>
                  </v-list-item>
                </div>
              </template>
            </Select>
          </v-col>
        </v-form>
      </v-col>
    </v-row>
  </Modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import colors from 'vuetify/lib/util/colors';
import Modal from '../shared/Modal';
import Input from '../shared/Input';
import Select from '../shared/Select';
import Tag from '@/domain/Tag';

export default {
  name: 'ModalTag',
  props: {
    modalTag: {
      type: Boolean,
      default: false
    },
    editTag: {
      default: null
    }
  },
  components: {
    Modal,
    Input,
    Select
  },
  data: () => ({
    valid: true,
    tag: new Tag(),
  }),
  watch: {
    modalTag(value) {
      if (!value) this.resetModalData();
    },
    editTag(value) {
      if (value) {
        this.tag = value;
      }
    },
  },
  computed: {
    ...mapGetters(['loading', 'rules']),
    colorsPicker() {
      const colorsArray = []

      for (const key of Object.keys(colors)) {
        if (!!colors[key] && !!colors[key].base) {
          colorsArray.push({ text: key, value: colors[key].base });
        }
      }

      return colorsArray;
    },
    computedTitle() {
      return this.editTag ? 'Edita Tag' : 'Nova Tag';
    }
  },
  methods: {
    ...mapActions(['createTag', 'updateTag']),
    resetModalData() {
      this.tag = new Tag();
      this.valid = true;
    },
    save() {
      if (this.$refs.tagForm.validate()) {
        if (this.editTag) {
          this.updateTag({ ...this.tag });
          this.$emit('close');
        } else {
          this.createTag({ ...this.tag });
          this.$emit('close');
        }
      }
    }
  }
}
</script>